import * as actionType from './actionTypes'
import * as common from './common'
import * as find from './find'
import * as join from './join'
import * as slip from './slip'
import * as myInfo from './myInfo'
import * as main from './main'
import * as asset from './asset'
import * as report from './report'
import * as manage from './manage'
import * as tax from './tax'
import * as debt from './debt'
import * as consulting from './consulting'
import * as scrap from './scrap'

export default {
    ...actionType, 
    ...common,
    ...find,
    ...join,
    ...slip,
    ...myInfo,
    ...main,
    ...asset,
    ...report,
    ...manage,
    ...tax,
    ...debt,
    ...consulting,
    ...scrap
}



// WEBPACK FOOTER //
// ./src/constants/index.js